import React from 'react';

import Hero from 'components/hero';
import { ReactComponent as Connection } from 'svg/illustrations/undraw_dev_focus_b9xo.svg';
import './style.css';

const WorkerWhy = () => {
  return (
    <Hero layout="vertical" className="worker-why bg-grey">
      <h2>Why MyShifts? How are we different from others?</h2>
      <div className="hero-content">
        <div className="worker-why-illustration">
          <Connection className="home-illustration " />
          <p className="footnote">
            * &apos;Agency&apos; - a means of exerting power or influence. Random
            House Kernerman Webster&apos;s College Dictionary, © 2010 K
            Dictionaries Ltd. Copyright 2005
          </p>
        </div>
        <div className="rich-text">
          <p>
            MyShifts is not an agency*, we do not place workers with employers.
          </p>
          <p>
            You hold the power to choose who you work for, when and how much you
            get paid, and influence your work patterns. You don’t need to be a
            limited company or self-employed. No expensive accountant bills and
            no surprise personal tax bills!
          </p>
          <p>
            Because we too have been in your position, of wanting extra shifts
            or to simply manage your work life balance better, we have created
            MyShifts. It is the best way to achieve this control.
          </p>
        </div>
      </div>
    </Hero>
  );
};

export default WorkerWhy;
